import { memo } from 'react';
import { XIcon } from '@page/icons';

import { Badge } from '../../designSystem/Badge';
import { IconButton } from '../../designSystem/IconButton';
import { cn } from '../../lib/styles';

export interface FilterBadgeProps {
  /** The chip's label — interactive content (e.g. a popover trigger button) is fine. */
  children: React.ReactNode;
  onRemove: () => void;
  /** Accessible name for the remove button, e.g. "Remove Status filter". */
  removeLabel: string;
  className?: string;
}

/** A removable filter chip: the gray pill Badge with a trailing remove button. */
const FilterBadgeBase = ({ children, onRemove, removeLabel, className }: FilterBadgeProps) => (
  <Badge
    variant="outline"
    color="lightGray"
    size="lg"
    className={cn('gap-0.5 pl-2.5 pr-0.5', className)}
    contentClassName="flex items-center gap-0.5 overflow-visible"
  >
    {children}

    <IconButton variant="tertiary" size="sm" rounded="full" aria-label={removeLabel} onClick={onRemove}>
      <XIcon className="size-3.5" />
    </IconButton>
  </Badge>
);

export const FilterBadge = memo(FilterBadgeBase);
